import { client } from '../http';

export default {
  async saveActivationSurveyAnswers({ answers }) {
    return await client.post('/api/survey/activation', { answers });
  },
};
